import { Injectable } from '@angular/core';
import { DataService } from 'src/app/core/services/api/data.service';
import { HeaderService } from 'src/app/core/services/header.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageEnum } from 'src/app/shared/enums/storage.enum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CasparService {
  constructor(
    private dataService: DataService<any>,
    private storageService: StorageService,
    private headerService: HeaderService
  ) { }

  getCasparActiveAlerts() {
    const fid = this.headerService.getFacilityId();
    const userId = this.storageService.getLocalStorage(
      StorageEnum.loginData,
      true
    )?.userId;
    const params = { userId, client: 'ondo' };
    const url = `${environment.apiUrl.caspar}${fid}/facilityCasparActiveAlertList`;
    return this.dataService.getData(url, params);
  }

  getCasparBedPresenseList() {
    const fid = this.headerService.getFacilityId();
    const userId = this.storageService.getLocalStorage(
      StorageEnum.loginData,
      true
    )?.userId;
    const params = { userId, client: 'ondo' };
    const url = `${environment.apiUrl.caspar}${fid}/facilityCasparBedPresenseList`;
    return this.dataService.getData(url, params);
  }

  getCasparIFrameParams(params: any = {}) {
    const userId = this.storageService.getLocalStorage(
      StorageEnum.loginData,
      true
    )?.userId;
    const token = this.storageService.getLocalStorage(
      StorageEnum.cst
    );
    const result = { userId, token, client: 'ondo', tab: 'alerts' };
    const obj = { ...result, ...params };
    const allowedKeys = ['userId', 'token', 'client', 'tab', 'patientId', 'bedId', 'insightId', 'insightid', 'alertId', 'alertid'];
    const filteredObj: any = {};
    allowedKeys.forEach(key => {
      if (obj[key] !== undefined && obj[key] !== null) {
        filteredObj[key] = obj[key];
      }
    });
    const csid = this.headerService.getCasparSiteId() || 'casparSiteIdIsNull';
    const paramsString = Object.keys(filteredObj)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filteredObj[key])}`)
      .join('&');
    return `${csid}?${paramsString}`;
  }

  setFallAlertStatus(roomId: string, alertId: string) {
    const userId = this.storageService.getLocalStorage(
      StorageEnum.loginData,
      true
    )?.userId;
    const fid = this.headerService.getFacilityId();
    const params = { userId, client: 'ondo' };
    const url = `${environment.apiUrl.caspar}${fid}/${alertId}/${userId}/${roomId}/takeAlertAndSilenceSoundAlarm`;
    return this.dataService.getData(url, params);
  }

  setFallAlertResolveStatus(alertId: string) {
    const userId = this.storageService.getLocalStorage(
      StorageEnum.loginData,
      true
    )?.userId;
    const fid = this.headerService.getFacilityId();
    const params = { userId, client: 'ondo' };
    const url = `${environment.apiUrl.caspar}${fid}/${alertId}/${userId}/tryResolvingCasparAlertForARoom`;
    return this.dataService.getData(url, params);
  }
}
